import api from './api';

export const ticketLinkService = {
  list: (ticketId) => api.get(`/tickets/${ticketId}/links`),
  create: (ticketId, data) => api.post(`/tickets/${ticketId}/links`, data),
  delete: (ticketId, linkId) => api.delete(`/tickets/${ticketId}/links/${linkId}`),
};
